import { reportErrorToConsole } from '@src/services/error-logger'
import { apiClient } from '@src/services/http-common'
import { SystemFlowModes } from '@src/types/dev-tools'
import { useQuery } from '@tanstack/react-query'

const SYSTEM_FLOW_MODES_ROUTE = 'dev-tools/system-flow-modes'

export const systemFlowModesKeys = {
  all: ['systemFlowModes'] as const,
}

const fetchSystemFlowModes = async (): Promise<SystemFlowModes> => {
  try {
    const response = await apiClient.get<SystemFlowModes>(SYSTEM_FLOW_MODES_ROUTE)
    return response.data
  } catch (error) {
    reportErrorToConsole(error)
    throw error
  }
}

export const useSystemFlowModes = () => {
  return useQuery({
    queryKey: systemFlowModesKeys.all,
    queryFn: fetchSystemFlowModes,
  })
}
